import Sortable, { Swap } from 'sortablejs';

Sortable.mount(new Swap());

var sorts = document.querySelectorAll('[data-sortable]');

function init(list) {
    var listOptions = list.dataset.sortable && JSON.parse(list.dataset.sortable);

    var defaultOptions = {};

    // Merge options
    var options = Object.assign(defaultOptions, listOptions);

    Sortable.create(list, options);
}

if (typeof Sortable !== 'undefined' && sorts) {
    [].forEach.call(sorts, function (sort) {
        init(sort);
    });
}